export default __webpack_public_path__ + "static/media/tituloES.151c5a29.png";